/*
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable compat/compat */
let unsupported;
const useSaveData = (initialSaveData = null) => {
    if (typeof navigator !== 'undefined' &&
        'connection' in navigator &&
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        'saveData' in navigator.connection) {
        unsupported = false;
    }
    else {
        unsupported = true;
    }
    return {
        unsupported,
        saveData: unsupported
            ? initialSaveData
            : // @ts-expect-error - remove once types are updated
                navigator.connection.saveData === true,
    };
};

export { useSaveData };
//# sourceMappingURL=index.js.map
